import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row } from 'reactstrap';

class CreateNewFaultForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      industry_failure_code: '',
      name: ''
    };

    this.toggle = this.toggle.bind(this);
  }

  handleChangeIndustryCode = (e) => {
    this.setState({
      industry_failure_code:e.target.value
    })
  };

  handleChangeLabel = (e) => {
    this.setState({
      name:e.target.value
    })
  };

  saveLabel = () => {
    this.props.handleCreateLabelToggle({name:this.state.name, industry_failure_code:this.state.industry_failure_code},
      !this.props.isToggleModal, this.props.feedback_type)
  };

  toggle() {
    this.props.handleCreateLabelToggle('', !this.props.isToggleModal, this.props.feedback_type)
  }

  render() {
    const { isToggleModal } = this.props;
    return (

      <Modal isOpen={isToggleModal} toggle={this.toggle} centered={true} className={'create-label-form'}>
        <ModalHeader toggle={this.toggle}>Create New Fault Label</ModalHeader>
        <ModalBody>
          <div>

            <Row>
              <label className="col-lg-4 cpl-md-4">Label Value</label>
              <div className="col-lg-8 cpl-md-8">
                <input name="name" onChange={this.handleChangeLabel} />
              </div>
            </Row>
            <Row>
              <label className="col-lg-4 cpl-md-4">Industry Failure Code (Optional)</label>
              <div className="col-lg-8 cpl-md-8">
                <input name="industry_failure_code" onChange={this.handleChangeIndustryCode} />
              </div>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.saveLabel}>Save</Button>
          <Button color="secondary" onClick={this.toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default CreateNewFaultForm;
